<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  [primaryButtonDisabled]="isBusy()"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (secondary)="onCancel()"
  (closed)="onCancel()"
>
  <div class="cdum-container">
    <!-- Drop zone -->
    <div
      class="cdum-dropzone"
      [class.cdum-dropzone--active]="isDragOver()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <label class="cdum-dropzone-label">
        <input
          type="file"
          class="cdum-dropzone-input"
          multiple
          [accept]="acceptAttribute"
          (change)="onFilesSelected($event)"
        />
        <span class="cdum-dropzone-button">
          <app-icon iconKey="upload" [showLabel]="false"></app-icon>
          <span>{{ 'ctx_upload_modal.choose_files' | transloco }}</span>
        </span>
      </label>
      <p class="cdum-dropzone-hint">{{ 'ctx_upload_modal.drop_hint' | transloco }}</p>
      <p class="cdum-dropzone-hint">{{ scopeHintKey() | transloco }}</p>
      <p class="cdum-dropzone-formats">{{ supportedFormatsLabel }}</p>
    </div>

    <!-- Upload rows -->
    @if (hasRows()) {
      <div class="cdum-summary" role="status">
        @if (isBusy()) {
          <span>{{
            (rows().length === 1
              ? 'ctx_upload_modal.uploading_one'
              : 'ctx_upload_modal.uploading_other'
            ) | transloco: { count: rows().length }
          }}</span>
        } @else {
          <span>
            {{ 'ctx_upload_modal.uploaded_count' | transloco: { count: successCount() } }}
            @if (errorCount() > 0) {
              · {{ 'ctx_upload_modal.failed_count' | transloco: { count: errorCount() } }}
            }
          </span>
        }
      </div>

      <ul class="cdum-rows" role="list" aria-live="polite">
        @for (row of rows(); track trackRow($index, row)) {
          <app-upload-row
            [fileName]="row.file.name"
            [fileMime]="row.file.type"
            [fileSize]="row.file.size"
            [status]="row.status"
            [errorMessage]="row.error"
            [errorIsDenial]="row.errorIsDenial"
            [canRetry]="true"
            (retry)="retryRow(row)"
            (dismiss)="removeRow(row)"
          />
        }
      </ul>
    }
  </div>
</app-modal>
